// src/components/Copyright.js
import React from 'react';
import { ExternalLink } from 'lucide-react';

const Copyright = ({ className = "" }) => {
  return (
    <div className={`w-full flex justify-center py-6 ${className}`}>
      <a 
        href="https://moyoo-bot.ru" 
        target="_blank" 
        rel="noreferrer"
        className="group flex items-center gap-1.5 opacity-40 hover:opacity-100 transition-opacity duration-300"
      >
        <div className="flex flex-col items-center">
            <span className="text-[9px] uppercase tracking-[0.2em] font-medium text-tg-hint group-hover:text-tg-button transition-colors">
                Developed by
            </span>
            <span className="text-[11px] font-bold text-tg-text tracking-widest group-hover:text-tg-button transition-colors mt-0.5 flex items-center gap-1">
                PixelFlow Ai <ExternalLink size={10} />
            </span>
        </div>
      </a>
    </div>
  );
};

export default Copyright;
